import styled from 'styled-components';
 const StyledTablaPKT1 = styled.div`

    .header{
        background: var(--HeaderTabla);
    }
`

export {StyledTablaPKT1}